// extracted by mini-css-extract-plugin
export default {"wrapper_block":"dashboard_wrapper_block__aWsw3"};